import React, { ReactNode } from 'react';
import Footer from '../Footer';

import Header from './../Header/';

interface ILayout{
    isLoginScreen?: boolean;
    children: ReactNode;
}

const Layout: React.FC<ILayout> = ({ isLoginScreen, children }: ILayout) => {
    return (
        <div className="flex min-h-screen flex-col">
            <Header isLoginScreen={isLoginScreen}/>
            <div className="flex-1">{children}</div>
            {!isLoginScreen && (<Footer />)}
        </div>
   );
}

export default Layout;